import { render, staticRenderFns } from "./NuevoRepartidor.vue?vue&type=template&id=ea549d78&"
import script from "./NuevoRepartidor.vue?vue&type=script&lang=js&"
export * from "./NuevoRepartidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports